<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module title="기본정보(담당자 정보)" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['department', 'com_name', 'rank', 'writer_name', 'date']" />

    <!-- 근로자 정보 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 근로자 정보</h5>
      <div class="writeGridContainer">
<!--        <div>-->
<!--          <div>사번</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>-->
<!--          <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly" />-->
<!--        </div>-->
        <div>
          <div>사업장명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <field-selector v-else v-model="form.inputA_3" :field-name="form.inputA_9" :readonly="board.readonly" @select="onSelectField"/>
        </div>
        <div>
          <div>팀명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
          <company-selector v-else v-model="form.inputA_4" :readonly="board.readonly" />
        </div>
        <div>
          <div>구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_5 }}</p>
          <vs-select v-else autocomplete v-model="form.inputA_5" :disabled="board.readonly">
            <vs-select-item v-for="item in select구분" :key="item" :text="item" :value="item" />
          </vs-select>
        </div>
        <div>
          <div>직종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_6 }}</p>
          <vs-select v-else autocomplete v-model="form.inputA_6" :disabled="board.readonly">
            <vs-select-item v-for="item in select직종" :key="item" :text="item" :value="item" />
          </vs-select>
        </div>
        <div>
          <div>성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_7 }}</p>
          <ml-input v-else v-model="form.inputA_7" :readonly="board.readonly" />
        </div>
<!--        <div>-->
<!--          <div>연락처</div>-->
<!--          <p v-if="isPrint" class="print-input">{{ form.inputA_8 }}</p>-->
<!--          <ml-input v-else v-model="form.inputA_8" :readonly="board.readonly" />-->
<!--        </div>-->
      </div>
    </div>

    <!-- 일반건강검진 정보 -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 일반건강검진 정보</h5>
      <div class="writeGridContainer">
<!--        <div>-->
<!--          <div>실시 유무</div>-->
<!--          <radio-text-input-->
<!--            :readonly="board.readonly"-->
<!--            :isPrint="isPrint"-->
<!--            radioName="radio_1"-->
<!--            :renderData="[-->
<!--              { textInput: false, value: '실시' },-->
<!--              { textInput: false, value: '미실시' },-->
<!--            ]"-->
<!--            v-model="form.inputB_1"-->
<!--          />-->
<!--        </div>-->
<!--        <div></div>-->
<!--        <div></div>-->
        <fragment v-if="!!form.inputB_1.value && form.inputB_1.value === '실시'">
          <div>
            <div>검진일</div>
            <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
            <date-selector v-else v-model="form.inputB_2" :readonly="board.readonly" />
          </div>
          <div></div>
          <div></div>
        </fragment>
        <div class="writeGridLineItem">
          <div>비고</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_3 }}</p>
          <ml-textarea v-else rows="5" v-model="form.inputB_3" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import EmployeeSelector from "@/components/selector/EmployeeSelector.vue";
import DateSelector from "@/components/selector/DateSelector";
import RadioTextInput from "@/components/radio/RadioTextInput";
import HttpRequest from "@/util/HttpRequest";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";

export default {
  components: {
    CompanySelector,
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
    EmployeeSelector,
    DateSelector,
    RadioTextInput,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      select구분: [
        "비현업",
        "현업 – 청사 등 시설물의 경비, 유지관리 업무 및 설비·장비 등의 유지관리",
        "현업 – 도로 유지·보수",
        "현업 – 도로·가로 청소, 쓰레기·폐기물 수거·처리 등 환경미화",
        "현업 – 공원·녹지 유지관리",
        "현업 - 산림조사·보호",
        "현업 - 조리시설",
      ],
      select직종: ["공무원", "공무직", "기간제", "공공근로", "장애인 일자리", "지역공동체", "자활근로", "기타"],
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",

        inputB_1: {},
        inputB_2: "",
        inputB_3: "",

        fileList: [],
      },
    };
  },
  methods: {
    onSelectEmployee(data) {
      HttpRequest.get(`/api/v1/field/${data.company_id}`).then((response) => {
        this.form.inputA_2 = response.facility_category.cat3;
      });

      this.form.inputA_3 = data.fields[0].field_name;
      this.form.inputA_4 = data.company.com_name;
      this.form.inputA_5 = data.job_category;
      this.form.inputA_6 = data.employment_type;
      this.form.inputA_7 = data.full_name;
      this.form.inputA_8 = data.contact_number;
    },
    onSelectField (field) {
      this.form.inputA_9 = field.field_name;
    }
  },
};
</script>

<style scoped lang="scss"></style>
